/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Pay_Book_UpsInputs */

const en_orders_pay_book_ups = /** @type {(inputs: Orders_Pay_Book_UpsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pay + Book UPS (${i?.count})`)
};

const es_orders_pay_book_ups = /** @type {(inputs: Orders_Pay_Book_UpsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pagar + reservar UPS (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Pay + Book UPS ({count})" |
*
* @param {Orders_Pay_Book_UpsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_pay_book_ups = /** @type {((inputs: Orders_Pay_Book_UpsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Pay_Book_UpsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_pay_book_ups(inputs)
	return es_orders_pay_book_ups(inputs)
});